import * as React from "react";
import { Dispatch } from "redux";
import { connect } from "react-redux";
import { StoreState } from "../../reducers/root-reducer";
import {
	WithStyles,
	Theme,
	createStyles,
	withStyles,
	ListItemSecondaryAction
} from "@material-ui/core";
import { InjectedTranslateProps, translate } from "react-i18next";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";

import { ConnectedSheet } from "../sheet";
import { SnackbarVariant } from "../../actions/store/type";
import { setSnackbarMessage } from "../../actions/store/snackbar-actions";
import {
	objectMatches,
	updateArrayByItemProp
} from "../../util/object-utility";
import { ConnectedSignatureList } from "./signature-list";
import { MessageSignature } from "../../api/settings";
import {
	updateSignature,
	addSignature,
	deleteSignature,
	addMeal,
	updateMeal,
	deleteMeal
} from "../../actions/settings-actions";
import { ConnectedMealList } from './meal-list';
import { Meal } from '../../api/meals';
import { IntegrationCommunicator } from '../../integration';

interface State {
	signatures: MessageSignature[];
	meals: Meal[]
}

type Props =
	WithStyles<typeof styles> &
	InjectedTranslateProps &
	ReturnType<typeof mapStateToProps> &
	ReturnType<typeof mapDispatchToProps>
;

export class Settings extends React.Component<Props, State> {
	public state: State = {
		signatures: [],
		meals: []
	};

	public componentDidMount() {
		this.setStateFromProps(this.props);
	}

	public componentWillReceiveProps(nextProps: Props) {
		this.setStateFromProps(nextProps);
	}

	private setStateFromProps = (props: Props) => {
		this.setState({
			signatures: props.signatures,
			meals: props.meals
		});
	};

	private handleAddSignature = (signature: MessageSignature) => {
		addSignature(signature);
	};

	private handleEditSignature = (signature: MessageSignature) => {
		updateSignature(signature.id, signature);
	};

	private handleDeleteSignature = (id: string) => {
		deleteSignature(id);
	};

	private handleAddMeal = (meal: MessageSignature) => {
		addMeal(meal);
	};

	private handleEditMeal = (meal: MessageSignature) => {
		updateMeal(meal.id, meal);
	};

	private handleDeleteMeal = (id: string) => {
		deleteMeal(id);
	};

	private handleAppSettingsClick = () => {
		IntegrationCommunicator.send("openSettings", {});
	};

	public render() {
		const { classes, t } = this.props;
		const { signatures, meals } = this.state;

		return (
			<ConnectedSheet maxWidth={1200}>
				<Typography
					className={classes.mainTitle}
					variant="headline"
					component="h3"
				>
					Einstellungen
				</Typography>
				<Typography className={classes.sectionTitle}>
					Signaturen
				</Typography>
				<ConnectedSignatureList
					signatures={signatures}
					onAdd={this.handleAddSignature}
					onEdit={this.handleEditSignature}
					onDelete={this.handleDeleteSignature}
				/>
				<Typography className={classes.sectionTitle}>
					Speisen
				</Typography>
				<ConnectedMealList
					meals={meals}
					onAdd={this.handleAddMeal}
					onEdit={this.handleEditMeal}
					onDelete={this.handleDeleteMeal}
				/>
				<Button onClick={this.handleAppSettingsClick} className={classes.button}>App-Einstellungen öffnen</Button>
			</ConnectedSheet>
		);
	}
}

const mapStateToProps = (state: StoreState) => ({
	signatures: state.settings.signatures,
	meals: state.settings.meals
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
	setSnackbarMessage: (message: string, variant: SnackbarVariant) =>
		dispatch(setSnackbarMessage(message, variant))
});

const styles = (theme: Theme) =>
	createStyles({
		container: {},
		mainTitle: {
			marginBottom: 25
		},
		sectionTitle: {
			fontSize: "1.2rem",
			fontWeight: 500,
			marginBottom: 10,
			marginTop: 25
		},
		button: {
			marginTop: 25,
		}
	});

export const ConnectedSettings = translate("translations")(
	withStyles(styles)(
		connect(
			mapStateToProps,
			mapDispatchToProps
		)(Settings)
	)
);
